module.exports = __webpack_public_path__ + "static/media/church.fcb4a7b2.svg";